<section
    class="parent container-fluid px-2 px-md-6 px-lg-8 sumary__info__location"
>
    <div class="parent__container px-3 py-2">
        <div class="container-fluid p-0">
            <div class="container g-0">
                <h2 class="title__info_location">
                    {{ 'fe_details_step5_location_detail_title' | translate }}
                </h2>
                <a
                    class="link__info_location d-flex align-items-center"
                    href="https://www.google.com/maps?q={{
                        locationDetails?.data?.destination?.lat
                    }},{{ locationDetails?.data?.destination?.lon }}"
                    target="_blank"
                    >{{ 'fe_details_step5_location_detail_link' | translate }}
                    <img
                        [src]="'images/external.svg' | cdn"
                        alt="location-redirect"
                /></a>
                <div class="d-flex align-items-start flex-column flex-md-row">
                    <div
                        class="iframe__container d-flex"
                        [innerHTML]="
                            locationDetails?.data?.destination?.urlMap ?? ''
                                | noSanitize
                        "
                        [ngClass]="{
                            'placeholder placeholder-wave w-50':
                                !locationDetails
                        }"
                    ></div>
                    <div class="location__info flex-column d-flex">
                        <a
                            href="https://www.google.com/maps?q={{
                                locationDetails?.data?.destination?.lat
                            }},{{ locationDetails?.data?.destination?.lon }}"
                            class="location__info_txt d-flex align-items-center"
                            target="_blank"
                        >
                            <img
                                [src]="'images/Branch_map.svg' | cdn"
                                alt="location-map-link"
                            />
                            <span
                                [ngClass]="{
                                    'placeholder placeholder-wave w-50':
                                        !locationDetails
                                }"
                            >
                                {{ addressLocation }}
                            </span>
                            <img
                                [src]="'images/external.svg' | cdn"
                                alt="external-link"
                                class="external-link-icon"
                            />
                        </a>

                        <a
                            href="tel:{{
                                locationDetails?.data?.destination?.phone
                            }}"
                            class="location__info_txt d-flex align-items-center"
                        >
                            <img
                                [src]="'images/Branch_mobile.svg' | cdn"
                                alt="location-phone-link"
                            />
                            <span
                                [ngClass]="{
                                    'placeholder placeholder-wave w-50':
                                        !locationDetails
                                }"
                            >
                                {{ locationDetails?.data?.destination?.phone }}
                            </span>
                            <img
                                [src]="'images/external.svg' | cdn"
                                alt="external-link"
                                class="external-link-icon"
                            />
                        </a>

                        <div
                            class="location__info_txt d-flex align-items-center"
                        >
                            <img
                                [src]="'images/Branch_clock.svg' | cdn"
                                alt="location-phone-link"
                            />
                            <span
                                [ngClass]="{
                                    'placeholder placeholder-wave w-50':
                                        !locationDetails
                                }"
                                >{{
                                    'fe_details_step5_location_detail_todays_schedule'
                                        | translate
                                        | replace
                                            : {
                                                  openHour,
                                                  closeHour
                                              }
                                }}
                            </span>
                        </div>
                    </div>
                </div>
                <div
                    class="justify-content-between d-flex service__location_container"
                >
                    <div class="d-flex flex-column">
                        <h2>
                            {{
                                'fe_details_step5_location_detail_second_part_title'
                                    | translate
                            }}
                        </h2>
                        <button
                            class="d-flex justify-content-between service__location_info align-items-center col-12 col-md-4 col-lg-3"
                            (click)="toggleInfoService()"
                        >
                            <a class="d-flex">
                                <img
                                    [src]="'images/check.svg' | cdn"
                                    alt="toggle-content"
                                />
                                <span>{{
                                    'fe_details_step5_location_detail_second_part_detail'
                                        | translate
                                }}</span>
                            </a>
                            <img
                                [src]="'images/chevron-down-amarillo.svg' | cdn"
                                alt="toggle-content"
                                class="more-detail-icon"
                                [ngClass]="{ active: infoServiceVisible }"
                            />
                        </button>

                        <div
                            class="dropdown__info col-12 col-md-4 col-lg-3"
                            [ngClass]="{ visible: infoServiceVisible }"
                        >
                            <p>
                                {{
                                    'fe_details_step5_location_detail_second_part_info'
                                        | translate
                                }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
